import withPaginationParams from '../../helpers/with-pagination-params';
import { z } from 'zod';

const listBaseSchema = z.object({
  uploadStartDate: z.date().optional(),
  uploadEndDate: z.date().optional(),
  paymentStartDate: z.date().optional(),
  paymentEndDate: z.date().optional(),
});

export const ListInterestPaymentsInput = withPaginationParams(listBaseSchema, [
  'dates',
  'createdAt',
  'totalInterest',
]).refine(
  (data) => {
    const hasUploadStart = !!data.uploadStartDate;
    const hasUploadEnd = !!data.uploadEndDate;

    const hasPaymentStart = !!data.paymentStartDate;
    const hasPaymentEnd = !!data.paymentEndDate;

    const uploadValid =
      (hasUploadStart && hasUploadEnd) || (!hasUploadStart && !hasUploadEnd);
    const paymentValid =
      (hasPaymentStart && hasPaymentEnd) ||
      (!hasPaymentStart && !hasPaymentEnd);

    return uploadValid && paymentValid;
  },
  {
    message:
      'If a start date is present, the corresponding end date must also be present.',
  },
);

export const DownloadInterestPaymentInput = z.object({
  uploadId: z.string(),
});

export const DeleteInterestPaymentInput = z.object({
  uploadId: z.string(),
});

export const CreateUploadDocumentInput = z.object({
  selectedTrancheIds: z.array(z.string()),
  interestPaymentsDate: z.date(),
});

export const ProcessUploadInput = z.object({
  filePath: z.string(),
  ignoreWarnings: z.boolean(),
});
